import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Lineicons } from '@lineiconshq/react-lineicons';
import { XmarkStroke } from '@lineiconshq/free-icons';
import React, { useState } from 'react';
import { AritoFormV2, BottomActionBarV2, FormFieldV2, AritoIcon } from '@/components/custom/erp';
import { Dialog, DialogOverlay, DialogPortal, DialogTitle } from '@/components/ui/dialog';
import { useDialogStack } from '@/hooks/use-dialog-stack';

interface ReviewProgressDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: BanHangPayload) => void;
}

const reviewerOptions = [
  { value: 'nhannn1804@gmail.com', label: 'THỰC TẬP SINH (NHANNN1804@GMAIL.COM)' },
  { value: 'hong@cjs.vn', label: 'hong@cjs.vn (hong@cjs.vn)' },
  { value: 'huyennt@ttmi.vn', label: 'NGUYỄN THANH HUYỀN (HUYENNT@TTMI.VN)' }
];

const ReviewProgressDialog: React.FC<ReviewProgressDialogProps> = ({ isOpen, onClose, onSubmit }) => {
  const { contentZIndex, overlayZIndex } = useDialogStack(isOpen);
  const [formValues, setFormValues] = useState<BanHangRecord>();

  const handleSubmit = (data: BanHangPayload) => {
    setFormValues(data);
    onSubmit(data);
  };

  const handleDirectSubmit = () => {
    onSubmit(formValues);
    onClose();
  };

  return (
    <Dialog modal={true} open={isOpen} onOpenChange={onClose}>
      <DialogPortal>
        <DialogOverlay className='fixed inset-0 bg-black/50' style={{ zIndex: overlayZIndex }} />
        <div className='fixed inset-0 flex items-center justify-center p-4' style={{ zIndex: contentZIndex }}>
          <DialogPrimitive.Content
            onOpenAutoFocus={event => event.preventDefault()}
            onCloseAutoFocus={event => event.preventDefault()}
            onInteractOutside={event => event.preventDefault()}
            onPointerDownOutside={event => event.preventDefault()}
            onFocusOutside={event => event.preventDefault()}
            className='flex max-h-[85vh] w-[640px] flex-col overflow-hidden border border-[#cfd8e3] bg-white shadow-lg outline-none'
          >
            <div className='flex h-11 min-h-11 items-center justify-between border-b border-[#d1d5db] bg-[#f2f7fc] pl-3.5 pr-4'>
              <DialogTitle className='flex items-center text-[16px] font-bold text-black'>
                <AritoIcon icon={12} className='mx-2' />
                <span>Chuyển đổi người duyệt đang trong tiến trình duyệt</span>
              </DialogTitle>
              <button type='button' onClick={onClose} className='inline-flex size-8 items-center justify-center'>
                <Lineicons aria-hidden='true' icon={XmarkStroke} className='size-[18px]' />
              </button>
            </div>
            <AritoFormV2
              mode='add'
              hasAritoActionBar={false}
              initialData={formValues}
              onSubmit={handleSubmit}
              className='w-full'
              headerFields={
                <div className='space-y-2 p-4'>
                  <FormFieldV2
                    labelClassName='w-40 min-w-40'
                    className='w-96'
                    label='Người duyệt cũ:'
                    name='oldReviewer'
                    type='select'
                    options={reviewerOptions}
                  />
                  <FormFieldV2
                    labelClassName='w-40 min-w-40'
                    className='w-96'
                    label='Người duyệt mới:'
                    name='newReviewer'
                    type='select'
                    options={reviewerOptions}
                  />
                  <FormFieldV2 labelClassName='w-40 min-w-40' className='w-96' label='Ghi chú:' name='note' />
                </div>
              }
              bottomBar={<BottomActionBarV2 mode='add' onClose={onClose} onSubmit={handleDirectSubmit} />}
            />
          </DialogPrimitive.Content>
        </div>
      </DialogPortal>
    </Dialog>
  );
};

export default ReviewProgressDialog;
